import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommandeService } from '../services/commande.service';
import { ProduitService } from '../services/produit.service';
import { SnackBarService } from '../services/snack-bar.service';
import { UserService } from '../services/user.service';
import { ZoneService } from '../services/zone.service';

@Component({
  selector: 'app-add-camion',
  templateUrl: './add-camion.component.html',
  styleUrls: ['./add-camion.component.scss']
})
export class AddCamionComponent implements OnInit {

 
 
  constructor(public dialogRef: MatDialogRef<AddCamionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,public userService:UserService,private distrubuteur:UserService,private produitService: ProduitService,private commandeService:CommandeService,private fb: FormBuilder, private zoneService: ZoneService, private _snackBar: SnackBarService) { }
  etatPadding: boolean = true;
  produits: any[] = [];
  users: any[] = [];
  zone: any;
  zoneForm = this.fb.group({
    immatriculation: ['', []],
    type: ['', []],
    nom: ['', []],
   chauffeur_id:['', []]
  });

  ngOnInit(): void {
  
    this.getProduits();
 
    this.distributeurs();
  }

  onSubmit(){
    this.etatPadding = false;
    this.chauffeur_id.setValue(this.userService.getUserDetails()._id);

    this.zoneService.addCamion(this.zoneForm.value).subscribe(res => {
      this._snackBar.openSnackBar("Camion Ajouter!!", "Fermer");
     console.log("Camion ",this.zoneForm.value);
      this.etatPadding = true;
      
      this.dialogRef.close();
    })
   
  
  }
  distributeurs()
  {
   this.distrubuteur.allUsersF().subscribe(res=>
     {
       this.users=res;
       console.log("Distributeur",this.users);
     })
 }

  get type(){
    return this.zoneForm.get('type');
  }

  get immatriculation(){
    return this.zoneForm.get('immatriculation');
  }
  get nom(){
    return this.zoneForm.get('nom');
  }
  get chauffeur_id(){
    return this.zoneForm.get('chauffeur_id');
  }

  getProduits(){
    this.produitService.getAllProduitByDistributeur().subscribe(res => {
     this.produits = res;
     console.log("produit",this.produits);
    });
  }


}
